import React from 'react';
import FeatureCardLayout from './FeatureCardLayout';
import './ChatCustomizationCard.css';

interface ChatCustomizationCardProps {
  isElite: boolean;
  bubbleColor1?: string | null;
  bubbleColor2?: string | null;
  onOpenBubbleColorModal?: () => void;
}

/**
 * The received and sent sample bubbles. Shared with the Elite showcase's
 * ProfileStudio (Asana 1219949663037427) so both render the same markup and CSS.
 */
export const ChatBubblePair: React.FC<{ sentBackground: string }> = ({ sentBackground }) => (
  <div className="chat-card-conversation">
    <div className="chat-card-msg chat-card-msg--received">
      <div className="chat-card-bubble chat-card-bubble--received">
        Thanks for the trade!
      </div>
    </div>
    <div className="chat-card-msg chat-card-msg--sent">
      <div
        className="chat-card-bubble chat-card-bubble--sent"
        style={{ background: sentBackground }}
      >
        You're so welcome! Let's do it again soon.
      </div>
    </div>
  </div>
);

const ChatCustomizationCard: React.FC<ChatCustomizationCardProps> = ({
  isElite,
  bubbleColor1,
  bubbleColor2,
  onOpenBubbleColorModal,
}) => {
  const c1 = bubbleColor1 || '#8B5CF6';
  const c2 = bubbleColor2 || '#6D28D9';
  const sentGradient = `linear-gradient(135deg, ${c1}, ${c2})`;

  const preview = (
    <div className="chat-card-preview">
      <ChatBubblePair sentBackground={sentGradient} />
    </div>
  );

  const cta = isElite ? (
    <button className="feature-card-btn" onClick={onOpenBubbleColorModal}>
      Customize Bubble Colors
    </button>
  ) : (
    <button className="feature-card-btn feature-card-btn--secondary" onClick={onOpenBubbleColorModal}>
      Try It Out
    </button>
  );

  return (
    <FeatureCardLayout
      title="Chat Customization"
      description="Personalize your chat bubbles with custom gradient colors and upload your own emoji for the entire community to use in reactions."
      previewContent={preview}
      ctaContent={cta}
      className="chat-card"
    />
  );
};

export default ChatCustomizationCard;
